import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M7.03167 3H15.5999V13.7857L14.0518 19.3583C13.8718 20.5447 12.6388 21.3356 11.3878 20.8593C10.6408 20.5716 10.1997 19.7987 10.1997 18.9987V14.6845C10.1997 14.1901 9.79473 13.7857 9.29972 13.7857H5.46563C3.88159 13.7857 2.71156 12.3117 3.06257 10.7747L4.6286 4.90546C4.88961 3.79094 5.87964 3 7.03167 3ZM19.2 3H17.3999V13.7857H19.2C20.19 13.7857 21 12.9767 21 11.9881V4.79761C21 3.80893 20.199 3 19.2 3Z' />
        </SvgIcon>
    );
});
